import * as React from 'react';
import * as I18n from 'i18n-js';
import { AdyenCardType } from '../lib/adyen';
import { useAdyenCard } from './adyen_card_hook';
import { useUser } from '@reverbdotcom/commons/dist/user_hooks';
import CreditCardEncryptedInput from './credit_card_encrypted_input';
import CreditCardEncryptedDateInput from './credit_card_encrypted_date_input';
import FormGroupWithInput from '@reverbdotcom/commons/dist/components/form_group_with_input';

export default function CreditCardNewCardFormFields() {
  const [cardholderName, setCardholderName] = React.useState(useUser().name || '');

  const { cardState, focus, errors, brand, endDigits } = useAdyenCard({
    selector: '[data-card-fields]',
    cardType: AdyenCardType.Card,
  });

  const { paymentMethod } = cardState.data;

  return (
    <div data-card-fields className="g-container">
      <div className="g-col-12 scaling-mb-2">
        <FormGroupWithInput
          inputName="credit_card[cardholder_name]"
          label={I18n.t('discovery.creditCardForm.nameOnCard')}
          value={cardholderName}
          updateField={(field) => setCardholderName(field.cardholderName)}
          fieldName="cardholderName"
          required
        />
      </div>
      <div className="g-col-12 scaling-mb-2">
        <CreditCardEncryptedInput
          inputName="credit_card[tokenized_data][encryptedCardNumber]"
          inputValue={paymentMethod.encryptedCardNumber}
          cseName="encryptedCardNumber"
          label={I18n.t('discovery.creditCardForm.cardNumber')}
          errors={errors}
          focus={focus}
        />
      </div>
      <div className="g-col-6 g-col-mobile-12 scaling-mb-2">
        <CreditCardEncryptedDateInput
          expiryMonthInputName="credit_card[tokenized_data][encryptedExpiryMonth]"
          expiryYearInputName="credit_card[tokenized_data][encryptedExpiryYear]"
          paymentMethod={paymentMethod}
          label={I18n.t('discovery.creditCardForm.expiration')}
          errors={errors}
          focus={focus}
        />
      </div>
      <div className="g-col-6 g-col-mobile-12 scaling-mb-2">
        <CreditCardEncryptedInput
          inputName="credit_card[tokenized_data][encryptedSecurityCode]"
          inputValue={paymentMethod.encryptedSecurityCode}
          label={I18n.t('discovery.creditCardForm.cvv')}
          cseName="encryptedSecurityCode"
          errors={errors}
          focus={focus}
        />
      </div>
      <input
        type="hidden"
        name="credit_card[type]"
        value={brand || ''}
      />
      <input
        type="hidden"
        name="credit_card[last_4]"
        value={endDigits || ''}
      />
    </div>
  );
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/credit_card_new_card_form_fields.tsx